import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLSelectElement} [variant]
 * @property {HTMLElement} price
 * @property {HTMLElement} compareAt
 * @extends {Component<Refs>}
 */
class TrendSpotPurchase extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.selectVariant();
  }

  updatedCallback() {
    super.updatedCallback();
    this.selectVariant();
  }

  /** Reflect the native selector in the price and matching colour image. */
  selectVariant() {
    const option = this.refs.variant?.selectedOptions[0];
    if (!option) return;
    this.refs.price.textContent = option.dataset.price || '';
    this.refs.compareAt.textContent = option.dataset.compare || '';
    this.refs.compareAt.hidden = !option.dataset.compare;
    const grid = this.closest('.ts-product-grid');
    if (!grid) return;
    for (const panel of grid.querySelectorAll('[data-jacket-image], [data-scarf-image]')) {
      const color = panel.dataset.jacketImage || panel.dataset.scarfImage;
      panel.hidden = color !== option.dataset.color;
    }
  }
}

if (!customElements.get('trendspot-purchase')) {
  customElements.define('trendspot-purchase', TrendSpotPurchase);
}

class TrendSpotGallery extends HTMLElement {
  connectedCallback() {
    this.onclick = (event) => {
      const button = event.target.closest('[data-gallery-select]');
      if (button && this.contains(button)) this.showPhoto(Number(button.dataset.gallerySelect));
    };
    this.onpointerdown = (event) => { this.startPoint = { x: event.clientX, y: event.clientY }; };
    this.onpointerup = (event) => {
      if (!this.startPoint || event.target.closest('button')) return;
      const dx = event.clientX - this.startPoint.x;
      const dy = event.clientY - this.startPoint.y;
      this.startPoint = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        const panels = [...this.querySelectorAll('[data-gallery-panel]')];
        const index = panels.findIndex(panel => !panel.hidden);
        this.showPhoto((index + (dx < 0 ? 1 : -1) + panels.length) % panels.length);
      }
    };
    this.onpointercancel = () => { this.startPoint = null; };
  }
  showPhoto(index) {
    this.querySelectorAll('[data-gallery-panel]').forEach(panel => {
      panel.hidden = Number(panel.dataset.galleryPanel) !== index;
    });
    this.querySelectorAll('[data-gallery-select]').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.gallerySelect) === index));
    });
  }
}
if (!customElements.get('trendspot-gallery')) customElements.define('trendspot-gallery', TrendSpotGallery);
